import { Badge, Box } from "@mui/material";
import LinkRouter from "../navigation/LinkRouter";
import { Document, DocumentType } from "protogen/documents_pb";
import { CalendarDays, ClipboardPen, FileText, ListTodo } from "lucide-react";
import {
  getDocumentLink,
  isFormDefinitionDocument,
} from "components/documents/utils";
import FeedEntryBox from "../common/FeedEntryBox";
import { PROD_ONBOARDING_AVAILABILITY_FORM_REF } from "components/documents/constants";

const DocumentIcon = ({ document }: { document: Document }) => {
  const color = "#6B6E7B";
  const size = 24;
  if (document.documentType === DocumentType.LIST) {
    return <ListTodo width={size} height={size} color={color} />;
  }
  if (document.documentType === DocumentType.FORM) {
    return isFormDefinitionDocument(document) ? (
      <ClipboardPen width={size} height={size} color={color} />
    ) : (
      <ClipboardPen width={size} height={size} color={color} />
    );
  }
  return <FileText width={size} height={size} color={color} />;
};

export default ({
  document,
  creatorName,
  unread = false,
}: {
  document: Document;
  creatorName: string;
  unread?: boolean;
}) => {
  // A special document to highlight in the feed
  const isOnboardingAvailabilityForm =
    document.sourceDocumentRef === PROD_ONBOARDING_AVAILABILITY_FORM_REF;

  const header = isOnboardingAvailabilityForm
    ? `${creatorName} - Onboarding Availability`
    : `${creatorName} created a new document: ${document.title}`;

  return (
    <LinkRouter to={getDocumentLink(document)}>
      <Box display="flex" flexDirection="column">
        <FeedEntryBox
          header={header}
          subheader=""
          unreadTreatment={unread}
          icon={
            <Badge
              color="secondary"
              variant="dot"
              overlap="circular"
              invisible={!unread}
              sx={{
                alignSelf: "center",
                ".MuiBadge-dot": {
                  top: "15%",
                  right: "5%",
                },
              }}
            >
              {isOnboardingAvailabilityForm ? (
                <CalendarDays width={24} height={24} color="#EF7B77" />
              ) : (
                <DocumentIcon document={document} />
              )}
            </Badge>
          }
        />
      </Box>
    </LinkRouter>
  );
};
